package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_08_01_Day_1
import com.veldekar.components.logs.Log_2026_08_01_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-08-01")
@Composable
public fun Log_2026_08_01(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Inevitable Breakup",
        ogTitle = "The Inevitable Breakup",
        date = LocalDate(2_026, 8, 1),
        aiHint = "Image shows a smart-phone chat between a D&D character and a sword (joke). Image shows Bigglesworth as a ghost -- this is a reference to 'ghosting' and not meant to be taken literally.",
        ogDescription = "The heroes stage an intervention, ending Bigglesworth’s toxic relationship with Razorwrath.",
        ogImage = "images/razorwrathGhosted.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-32", dateString = "Shimmer 32")
        Log_2026_08_01_Day_1()
        SessionDayHeader(dayId = "shimmer-33", dateString = "Shimmer 33")
        Log_2026_08_01_Day_2()
        SessionMediaItem(
            image = "images/pathToPentish.webp",
            linkImage = "images/pathToPentish.webp",
            width = 1_752,
            height = 3_216,
        )
    }
}
